import { AlertTriangle } from 'lucide-react';

export default function DemoDataBanner({ note }) {
  return (
    <div
      className="mx-5 mt-3 px-3 py-2 rounded-md flex items-start gap-2"
      style={{ background: 'rgba(242, 166, 0, 0.08)', border: '1px solid rgba(242, 166, 0, 0.35)' }}
    >
      <AlertTriangle size={14} style={{ color: '#A37300', flexShrink: 0, marginTop: 1 }} />
      <div className="text-[11px] leading-snug" style={{ color: '#7A5500' }}>
        <span className="font-bold">Demo data</span> — illustrative prices, not live. {note}
      </div>
    </div>
  );
}
